import { FirebaseAuth } from '../FirebaseService/auth';
import { ClaimScoreApiVersion } from './types';

export const CLAIMSCORE_API_URL = import.meta.env.VITE_CLAIMSCORE_API_URL;

export const getBaseURLWithVersion = (
  version: ClaimScoreApiVersion,
): string => {
  return `${CLAIMSCORE_API_URL}/${version}`;
};

export const getAuthorizationToken = async (): Promise<string> => {
  const authorizationToken = await FirebaseAuth.getAuthToken();

  return `Bearer ${authorizationToken}`;
};
